<template>
  <div class="loginForm modal fade" id="dealerModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-3"></column>
      <column class="col-md-6">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">Dealer Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Dealer Name" v-model="fullName" />
                </div>
              </div>
              <!--<div class="form-group">
                <label class="col-sm-3 control-label">Last Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Last Name" v-model="lastName" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Email</label>
                <div class="col-sm-9">
                  <input type="email" class="form-control" placeholder="Email" v-model="email" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Phone</label>
                <div class="col-sm-9">
                  <input type="tel" class="form-control" placeholder="Phone" v-model="phone" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Address</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Address" v-model="address" />
                </div>
              </div>-->
              <div class="form-group" align="center">
                <va-alert type="danger" :dismissible="true" v-show="error" style="width: 98%;">
                  <div slot="body">
                    <i class="icon fa fa-ban"></i> {{error}}
                  </div>
                </va-alert>
              </div>
            </form>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
            <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="save" style="margin-right: 10px;"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-3"></column>
    </row>
  </div>
</template>
<script>
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'

  import { db } from '../firebase'

  export default {
    name: 'AddDealer',
    data () {
      return {
        dealerKey: '',
        title: 'Add Dealer',
        fullName: '',
        email: '',
        phone: '',
        address: '',
        totalSites: 0,
        totalPrinters: 0,
        error: ''
      }
    },
    created () {

    },
    mounted () {
      this.$bus.$on('dealerModal-open', (args) => {
        // console.log(args)
        if (args) {
          this.title = 'Edit Dealer' + ' [' + args.FullName + ']'
          this.dealerKey = args['.key']
          this.fullName = args.FullName
          this.totalCustomers = args.TotalCustomers
          this.totalSites = args.TotalSites
          this.totalPrinters = args.TotalPrinters
          this.error = ''
        } else {
          this.title = 'Add Dealer'
        }
        $('#dealerModal').modal('show')
      })
    },
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton
    },
    methods: {
      save () {
        let vm = this
        if (vm.isValid()) {
          const dealer = {
            FullName: vm.fullName,
            TotalCustomers: vm.totalCustomers,
            TotalSites: vm.totalSites,
            TotalPrinters: vm.totalPrinters
          }

          if (vm.dealerKey) {
            const dealerRef = db.ref('Dealers/' + vm.dealerKey + '/FullName')
            dealerRef.set(dealer.FullName)
          } else {
            /*
            const dealerRef = db.ref('Dealers/')
            dealerRef.push(dealer)

            db.ref('Dashboard/Admin/TotalDealers').once('value').then(function (snapTotalDealers) {
              let totalDealers = snapTotalDealers.val()
              db.ref('Dashboard/Admin/TotalDealers').set(totalDealers + 1)
            })
            */
          }

          vm.reset()
          vm.$root.reloadSlideItems()
          $('#dealerModal').modal('hide')
        }
      },
      cancel () {
        this.reset()
        $('#dealerModal').modal('hide')
      },
      isValid () {
        this.error = ''

        if (this.fullName.length === 0) {
          this.error = '* Please enter Dealer Name!'
          return false
        }

        return true
      },
      reset () {
        this.firstName = ''
        this.lastName = ''
        this.email = ''
        this.phone = ''
        this.address = ''
        this.error = ''
      }
    }
  }

</script>



// WEBPACK FOOTER //
// AddDealer.vue?3b0d8649